import { EEntityType } from '../../repositories/favorites/entities/favorite_entity_for_desktop/FavoriteEntityForDesktop';
import type { IGetFavoritesForDesktopResponse } from '../../repositories/favorites/entities/get_favorites_for_desktop/GetFavoritesForDesktopResponse';

export interface IFavoritesState {
  count: number;
  favoriteItems: IGetFavoritesForDesktopResponse['favoriteEntities'];
  status: EFavoritesStatus;
  activeRequestId?: number;
}

export enum EFavoritesStatus {
  Initial = 'initial',
  Loading = 'loading',
  Succeed = 'succeed',
  Failed = 'failed',
}

export { EEntityType as EFavoritesItemEntityType };
